import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Impulse day",
  "description": "",
  "published": "2006-11-11T00:00:00.000Z",
  "redirect_from": ["/blog/impulse-day/swizec/362"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`As it would appear today was a very impulsive day as there were many things that occured on pure impulse.`}</p>
    <p>{`One of such things was the idea to go and get some new hair to crown my head with and it really turned out quite well, I like it and it's a nice, although huge, change. It was done in a true silly person manner as well, when I got there I pulled out a screencap of Depp from Secret Window and said that I wanted that. Promptly enough the hair went from nipple length to just short of chin length.`}</p>
    <p>{`The other thing was an impulse buy of the trashiest of trashy newspapers the country has to offer for the reason of getting a Fawly Towers DVD. Sad part is I got burned and it only contains 3 episodes and those in not too good quality, stupid thing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      